import React, { useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { auth } from "../utils/firebase";

const MainLayout = () => {
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const checkIfUser = async () => {
    setLoading(true);
    const currentUser = auth.currentUser;
    if (!currentUser) {
      navigate("/login");
    }
    setLoading(false);
  };

  useEffect(() => {
    checkIfUser();
  }, [pathname]);
  if (loading) return <div></div>;
  return (
    <div className="">
      <div className="overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
